import { NgModule } from '@angular/core';
import { Route, RouterModule,  } from '@angular/router';
import { LoginComponent } from '../components/login/login.component';
import { AuthGuard } from '../guards/auth.guard';
const appRoutes: Route[] = [
  { path: 'login', component: LoginComponent },
  { path: 'pages', loadChildren: () => import('../modules/pages/pages.module').then(m => m.PagesModule) , canActivate: [AuthGuard] },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', redirectTo: 'login' },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
